module.exports = __webpack_public_path__ + "static/media/Minor Repairs.3ff3680a.png";